import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { ClientiApi} from "../data/apis/ClientiApi";

export function customersDataSource(idCliente: string) {
  return new CustomStore({
      key: "id",
      loadMode : 'raw',
      load: (loadOptions) => {
          const api = new ClientiApi(apiConfiguration);
          
          return api.getClienti();
      },
      
      byKey: (key) => {
        const api = new ClientiApi(apiConfiguration);

          return api.getClienteById({
            idCliente:key
        });
      },

      insert: (values) => {
          const api = new ClientiApi(apiConfiguration);

          return api.insertCliente({              
            clienteCreateDTO: values
          });
      },

      update: (key, values) => {
          const api = new ClientiApi(apiConfiguration);
          return api.updateCliente({
              idCliente:idCliente,
              clienteUpdateDTO:values          
          });
      }
  });
}
